import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const whatsappLink =
    "https://chat.whatsapp.com/H14ERLaDbbN8oA7AcGBVoE?mode=r_c";

  return (
    <a
      href={whatsappLink}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp size={28} />
      <span className="whatsapp-text">Join our community</span>
    </a>
  );
};

export default WhatsAppButton;
